import SearchIcon from "@mui/icons-material/Search";
import { InputAdornment, TextField } from "@mui/material";
import { format } from "date-fns";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { getBankDropdownList } from "../../../billing/services/PatientAdvanceServices";
import CommonButton from "../../../common/components/Buttons/CommonButton";
import CommonBackDrop from "../../../common/components/CommonBackDrop/CommonBackDrop";
import CommonDynamicTableNew from "../../../common/components/CommonTable/CommonDynamicTableNew";
import ConfirmationModal from "../../../common/components/ConfirmationModal";
import DatePickerField from "../../../common/components/FormFields/DatePickerFieldNew";
import DropdownField from "../../../common/components/FormFields/DropdownField";
import RadioField from "../../../common/components/FormFields/RadioField";
import {
  errorAlert,
  successAlert,
  warningAlert,
} from "../../../common/components/Toasts/CustomToasts";
import {
  fetchPaymentModeChangeDetailsByBillNo,
  savePaymentModeChangeByBillNo,
} from "../../services/paymentModeChangeServices/PaymentModeChangeServices";
import { getPaymentMode } from "../../../billing/services/BillingServices";

const type = [
  {
    id: 0,
    value: 0,
    label: "OPD",
  },
  {
    id: 1,
    value: 1,
    label: "IPD",
  },
  {
    id: 2,
    value: 2,
    label: "Pharmacy",
  },
];
const PaymentModeChange = () => {
  const [billDetailedInfo, setBillDetailedInfo] = useState(null);
  const [modeOfPaymentList, setModeOfPaymentList] = useState([]);
  const [openBackdrop, setOpenBackdrop] = useState(false);
  const [originalPaidAmount, setOriginalPaidAmount] = useState(0);
  const [paymentTotal, setPaymentTotal] = useState(0);
  const [openPost, setOpenPost] = useState(false);
  const [bankOptions, setBankOptions] = useState([]);
  const [paymentModeOptions, setPaymentModeOptions] = useState([]);
  const { control, watch, setValue, register, reset } = useForm({
    defaultValues: {
      billNo: "",
      type: 0,
      fromDate: new Date(),
      toDate: new Date(),
    },
  });

  let getBillNo = watch("billNo");
  let getType = watch("type");
  let getFromDate = watch("fromDate");
  let getToDate = watch("toDate");

  const paymentDetailsByBillNo = (paymentId) => {
    setOpenBackdrop(true);
    fetchPaymentModeChangeDetailsByBillNo({
      type: getType,
      billNo: getBillNo,
      fromDate: format(getFromDate, "yyyy-MM-dd"),
      toDate: format(getToDate, "yyyy-MM-dd"),
      paymentId: paymentId,
    })
      .then((response) => {
        const paymentModeList = response?.data?.result?.paymentModeList?.map(
          (item) => ({
            ...item,
            validityDate: item.validityDate
              ? format(new Date(item.validityDate), "yyyy-MM-dd'T'HH:mm:ss")
              : null,
          }),
        );

        const totalPaidAmount = paymentModeList?.reduce(
          (sum, item) => sum + Number(item?.paidAmount || 0),
          0,
        );

        setOriginalPaidAmount(totalPaidAmount);
        setPaymentTotal(totalPaidAmount);

        setOpenBackdrop(false);
        setBillDetailedInfo(response?.data?.result);
        setModeOfPaymentList(paymentModeList);
      })
      .catch((error) => {
        console.log("error", error);
        errorAlert(error.message);
        setOpenBackdrop(false);
      });
  };

  const renderInput = (row, index, header) => {
    setValue(
      `bankName${index}`,
      row?.bankName !== null
        ? {
            id: row?.bankId,
            value: row?.bankId,
            label: row?.bankName,
          }
        : null,
    );

    return (
      <div className="my-1.5">
        {header === "Pay Mode" && (
          <DropdownField
            control={control}
            name={`payMode${index}`}
            dataArray={paymentModeOptions}
            placeholder="Pay Mode"
            inputRef={{
              ...register(`payMode${index}`, {
                onChange: (e) => {
                  const temp = [...modeOfPaymentList];

                  const label = e.target.value?.label;

                  temp[index].PaymentType = e.target.value?.id ?? null;

                  if (label === "CASH") {
                    temp[index].payMode = "Cash";
                    temp[index].documentNo = "";
                    temp[index].bankId = null;
                    temp[index].bankName = null;
                    temp[index].validityDate = null;
                  } else if (label === "CHEQUE") {
                    temp[index].payMode = "Cheque";
                  } else if (label === "CREDIT CARD") {
                    temp[index].payMode = "CreditCard";
                  } else if (label === "DEBIT CARD") {
                    temp[index].payMode = "DebitCard";
                  } else if (label === "ECS") {
                    temp[index].payMode = "ECS";
                  } else {
                    temp[index].payMode = null;
                  }

                  setModeOfPaymentList(temp);
                },
              }),
            }}
          />
        )}
        {header === "Paid Amount" && (
          <input
            type="number"
            value={row?.paidAmount}
            name={`paidAmount${index}`}
            className={`border rounded px-1 h-8 ${
              // Number(row?.paidAmount) <= 0
              //   ? "border-red-500"
              //   :
              paymentTotal !== originalPaidAmount
                ? "border-red-500"
                : "border-black"
            }`}
            onChange={(e) => {
              let temp = [...modeOfPaymentList];
              temp[index].paidAmount = Number(e.target.value);
              setModeOfPaymentList(temp);
              const totalValue = temp.reduce(
                (sum, item) => sum + Number(item?.paidAmount || 0),
                0,
              );

              setPaymentTotal(totalValue);
            }}
          />
        )}
        {header === "Document No" && (
          <input
            disabled={row?.payMode === "Cash"}
            type="number"
            value={row?.documentNo}
            name={`documentNo${index}`}
            className={`border rounded px-1 h-8 ${
              row?.payMode !== "Cash" &&
              (!row?.documentNo || Number(row?.documentNo) <= 0)
                ? "border-red-500"
                : "border-black"
            }`}
            onChange={(e) => {
              let temp = [...modeOfPaymentList];
              temp[index].documentNo = Number(e.target.value);
              setModeOfPaymentList(temp);
            }}
          />
        )}
        {header === "Actions" && (
          <CommonButton
            label={"Add Row"}
            className={"px-3 rounded bg-customBlue text-white"}
            type={"button"}
            onClick={() => {
              paymentDetailsByBillNo(row?.payModeId);
            }}
          />
        )}
        {header === "Bank Name" && (
          <DropdownField
            isDisabled={row?.payMode === "Cash"}
            control={control}
            name={`bankName${index}`}
            placeholder="Bank Name"
            className="border-black rounded px-1"
            dataArray={bankOptions}
            isClearable={true}
            isSearchable={true}
            inputRef={{
              ...register(`bankName${index}`, {
                onChange: (e) => {
                  let temp = [...modeOfPaymentList];
                  temp[index].bankId =
                    e.target.value !== null ? e.target.value?.id : null;
                  temp[index].bankName =
                    e.target.value !== null ? e.target.value?.label : null;
                  setModeOfPaymentList(temp);
                },
              }),
            }}
          />
        )}
        {header === "Validity Date" && (
          <div className="w-40">
            <DatePickerField
              disabled={row?.payMode === "Cash"}
              control={control}
              name={`validityDate${index}`}
              label="Validity Date"
              inputFormat="dd-MM-yyyy"
              inputRef={{
                ...register(`validityDate${index}`, {
                  onChange: (e) => {
                    let temp = [...modeOfPaymentList];
                    temp[index].validityDate = format(
                      e.target.value,
                      "yyyy-MM-dd'T'HH:mm:ss",
                    );

                    setModeOfPaymentList(temp);
                  },
                }),
              }}
            />
          </div>
        )}
      </div>
    );
  };

  const savePaymentModeInfo = () => {
    setOpenBackdrop(true);
    savePaymentModeChangeByBillNo({
      paymentId: billDetailedInfo?.PaymentId,
      paymentModeList: modeOfPaymentList,
      type: Number(getType),
    })
      .then((response) => {
        setOpenBackdrop(false);
        successAlert(response.data.message);
        setOpenPost(false);
        reset();
        setBillDetailedInfo(null);
        setModeOfPaymentList([]);
        setPaymentTotal(0);
        setOriginalPaidAmount(0);
      })
      .catch((error) => {
        setOpenBackdrop(false);
        errorAlert(error.message);
        setOpenPost(false);
      });
  };

  useEffect(() => {
    getBankDropdownList().then((response) => {
      setBankOptions(response?.data?.result);
    });
  }, []);

  useEffect(() => {
    getPaymentMode().then((response) => {
      setPaymentModeOptions(response?.data?.result);
    });
  }, []);

  useEffect(() => {
    if (paymentModeOptions.length && modeOfPaymentList.length) {
      modeOfPaymentList.forEach((row, index) => {
        let payMode = row?.payMode;

        if (payMode === "Online") {
          payMode = "ECS";
          row.payMode = "ECS";
        }

        const selectedMode = paymentModeOptions.find((item) => {
          if (payMode === "CreditCard") {
            return item.label === "CREDIT CARD";
          }

          if (payMode === "DebitCard") {
            return item.label === "DEBIT CARD";
          }

          return item.label?.toLowerCase() === payMode?.toLowerCase();
        });

        setValue(`payMode${index}`, selectedMode || null);
        row.PaymentType = selectedMode?.id ?? null;
      });
    }
  }, [paymentModeOptions, modeOfPaymentList, setValue]);
  useEffect(() => {
    if (bankOptions.length && modeOfPaymentList.length) {
      modeOfPaymentList.forEach((row, index) => {
        const selectedBank = bankOptions.find(
          (item) =>
            item?.id === row?.bankId ||
            item.label?.toLowerCase() === row.bankName?.toLowerCase(),
        );

        setValue(`bankName${index}`, selectedBank || null);
      });
    }
  }, [bankOptions, paymentModeOptions]);

  useEffect(() => {
    if (modeOfPaymentList.length) {
      modeOfPaymentList.forEach((row, index) => {
        setValue(
          `validityDate${index}`,
          row?.validityDate &&
            row.validityDate !== "1899-12-31T18:30:00.000+00:00"
            ? new Date(row.validityDate)
            : null,
        );
      });
    }
  }, [modeOfPaymentList, setValue]);

  const handleAddRow = () => {
    setModeOfPaymentList((prev) => [
      ...prev,
      {
        PatientName: billDetailedInfo?.paymentModeList?.[0]?.PatientName,
        MRNo: billDetailedInfo?.paymentModeList?.[0]?.MRNo,
        BillId: billDetailedInfo?.paymentModeList?.[0]?.BillId,
        BillDate: billDetailedInfo?.paymentModeList?.[0]?.BillDate,
        PaymentType: null,
        payModeId: 0,
        payMode: null,
        paidAmount: null,
        documentNo: "",
        bankName: "",
        bankId: null,
        validityDate: null,
      },
    ]);
  };

  return (
    <div className="mt-12 mb-2 space-y-2">
      <div className="text-center text-black font-bold text-xl">
        Payment Mode Change
      </div>
      <div className="grid grid-cols-2 lg:grid-cols-6 xl:grid-cols-8 2xl:grid-cols-10 gap-3">
        <fieldset className="flex gap-1 justify-center items-center bg-white border rounded px-2 -mt-2 lg:col-span-2">
          <legend className="font-semibold text-xs px-2">Bill Type</legend>
          <div className="-my-2 whitespace-nowrap">
            <RadioField control={control} name="type" dataArray={type} />
          </div>
        </fieldset>
        <div className="">
          <TextField
            control={control}
            name="billNo"
            size="small"
            {...register("billNo")}
            label="Bill No"
            inputProps={{
              style: {
                textTransform: "capitalize",
                fontSize: "14px",
                height: "18px",
              },
            }}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <SearchIcon />
                </InputAdornment>
              ),
            }}
          />
        </div>
        <div className="flex space-x-2 lg:col-span-2">
          <DatePickerField
            control={control}
            name="fromDate"
            label="From Date"
            inputFormat="dd-MM-yyyy"
          />
          <DatePickerField
            control={control}
            name="toDate"
            label="To Date"
            inputFormat="dd-MM-yyyy"
          />
        </div>
        <CommonButton
          type="button"
          searchIcon={true}
          className="bg-customBlue text-white"
          onClick={() => {
            if (getBillNo !== "") {
              paymentDetailsByBillNo(0);
            } else {
              warningAlert("Enter bill no...!");
            }
          }}
        />
      </div>
      <div className="bg-[#F1F1F1] border rounded grid grid-cols-4 lg:grid-cols-5 xl:grid-cols-7 lg:justify-between px-2 py-1 text-[15px]">
        <div className="flex items-center text-customBlue font-semibold col-span-2">
          <label className="">Patient Name</label>
          <label>
            &nbsp;:&nbsp;{billDetailedInfo?.paymentModeList?.[0]?.PatientName}
          </label>
        </div>
        <div className="flex items-center">
          <label className="font-semibold">MR No</label>
          <label>
            &nbsp;:&nbsp;{billDetailedInfo?.paymentModeList?.[0]?.MRNo}
          </label>
        </div>
        <div className="flex items-center">
          <label className="font-semibold">Bill Date</label>
          <label>
            &nbsp;:&nbsp;{billDetailedInfo?.paymentModeList?.[0]?.BillDate}
          </label>
        </div>
      </div>
      <div className="flex w-full justify-between">
        <div className="flex w-full space-x-5">
          <div className="flex items-center">
            <label className="font-semibold">Bill Amount :&nbsp;</label>
            <label>
              ₹ {billDetailedInfo?.paymentModeList?.[0]?.TotalBillAmount}
            </label>
          </div>
          <div className="flex items-center">
            <label className="font-semibold">Net Amount :&nbsp;</label>
            <label>
              ₹ {billDetailedInfo?.paymentModeList?.[0]?.NetBillAmount}
            </label>
          </div>
          <div className="flex items-center">
            <label className="font-semibold">Paid Amount :&nbsp;</label>
            <label>₹ {originalPaidAmount}</label>
          </div>
        </div>
        {/* <div className="flex justify-end">
          <CommonButton
            type="button"
            label="Add Row"
            className="bg-customBlue text-white"
            onClick={handleAddRow}
          />
        </div> */}
      </div>
      <div>
        {modeOfPaymentList?.length > 0 ? (
          <CommonDynamicTableNew
            dataResult={modeOfPaymentList?.map((val) => ({
              ...val,
              "Pay Mode": val.payMode,
              "Paid Amount": val.paidAmount,
              "Document No": val.documentNo,
              "Bank Name": val.bankName,
              "Validity Date": val.validityDate,
              Actions: "",
            }))}
            removeHeaders={[
              "bankId",
              "payMode",
              "validityDate",
              "documentNo",
              "bankName",
              "paidAmount",
              "MRNo",
              "BillId",
              "PaymentId",
              "BillDate",
              "PaymentId",
              "PayModeId",
              "payModeId",
              "PatientName",
              "PaymentType",
              "NetBillAmount",
              "TotalBillAmount",
            ]}
            renderInput={renderInput}
            editableColumns={[
              "Paid Amount",
              "Bank Name",
              "Document No",
              "Validity Date",
              "Pay Mode",
              "Actions",
            ]}
            highlightRow={false}
          />
        ) : (
          <div className="h-60 border rounded flex items-center justify-center font-semibold">
            No Payments Found...
          </div>
        )}
      </div>
      <div className="flex space-x-2 justify-end">
        <CommonButton
          type="button"
          label="Reset"
          className="border border-customRed text-customRed"
          onClick={() => {
            reset();
            setBillDetailedInfo(null);
            setModeOfPaymentList([]);
            setPaymentTotal(0);
            setOriginalPaidAmount(0);
          }}
        />

        <CommonButton
          type="button"
          label="Save"
          disabled={modeOfPaymentList?.length === 0}
          className="bg-customGreen text-white"
          onClick={() => {
            const invalidPayMode = modeOfPaymentList?.find(
              (item) => !item?.payMode,
            );
            const invalidPaymentDetails = modeOfPaymentList.find((item) => {
              if (item?.payMode === "Cash") {
                return false;
              }

              return !item?.bankId || !item?.documentNo || !item?.validityDate;
            });

            if (invalidPaymentDetails) {
              warningAlert(
                "Bank Name, Document No and Validity Date are mandatory for non-cash payment modes.",
              );
              return;
            }
            if (invalidPayMode) {
              warningAlert("Please Select Pay Mode for all Records.");
              return;
            }
            const invalidPaidAmount = modeOfPaymentList.find(
              (item) => Number(item?.paidAmount) <= 0,
            );

            // if (invalidPaidAmount) {
            //   warningAlert("Paid Amount should be greater than 0.");
            //   return;
            // }

            if (paymentTotal !== originalPaidAmount) {
              warningAlert("Payable Total Do Not Match with 'Paid Amount'");
              return;
            }

            setOpenPost(true);
          }}
        />
      </div>
      <ConfirmationModal
        confirmationOpen={openPost}
        confirmationHandleClose={() => setOpenPost(false)}
        confirmationSubmitFunc={savePaymentModeInfo}
        confirmationLabel="Confirmation"
        confirmationMsg="Are you sure want to save this changes...!"
        confirmationButtonMsg="Confirm"
      />
      <CommonBackDrop openBackdrop={openBackdrop} />
    </div>
  );
};

export default PaymentModeChange;
